import React, { Component } from 'react';
import ScrollToTop from '../scroll-to-top/ScrollToTop';
import FooterMobileAccordion from './FooterMobileAccordion';

class FooterMobile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="footer-mobile">
        <ScrollToTop />
        {this.props.primaryNav.children.map((item, index) => {
          return (
            <FooterMobileAccordion
              title={item.title}
              key={index}
              children={item.children}
              link={item.link}
            />
          );
        })}
      </div>
    );
  }
}

export default FooterMobile;
